import { moebiusEase, squashUnit, StringMapping, Terminator, ValueMapping } from "@opendaw/lib-std";
import { GroovePattern, PPQN } from "@opendaw/lib-dsp";
import { ParameterAdapterSet } from "../ParameterAdapterSet";
export class GrooveShuffleBoxAdapter {
    static Durations = [
        [1, 8], [1, 4], [1, 4], [1, 2], [1, 1], [2, 1], [4, 1], [8, 1], [16, 1]
    ];
    static DurationPPQNs = GrooveShuffleBoxAdapter.Durations.map(([n, d]) => PPQN.fromSignature(n, d));
    static DurationStrings = GrooveShuffleBoxAdapter.Durations.map(([n, d]) => (`${n}/${d}`));
    type = "groove-adapter";
    #terminator = new Terminator();
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    #groove = new GroovePattern({
        duration: () => this.#duration,
        fx: x => moebiusEase(x, this.#amount),
        fy: y => moebiusEase(y, 1.0 - this.#amount)
    });
    #amount = 0.0;
    #duration = PPQN.SemiQuaver * 2;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = this.#terminator.own(new ParameterAdapterSet(this.#context));
        this.namedParameter = this.#wrapParameters(box);
        this.#terminator.ownAll(this.namedParameter.duration.catchupAndSubscribe(owner => this.#duration = owner.getValue()), this.namedParameter.amount.catchupAndSubscribe(owner => this.#amount = squashUnit(owner.getValue(), 0.01)));
    }
    unwarp(position) { return this.#groove.unwarp(position); }
    warp(position) { return this.#groove.warp(position); }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    terminate() { this.#terminator.terminate(); }
    #wrapParameters(box) {
        return {
            duration: this.#parametric.createParameter(box.duration, ValueMapping.values(GrooveShuffleBoxAdapter.DurationPPQNs), StringMapping.values("", GrooveShuffleBoxAdapter.DurationPPQNs, GrooveShuffleBoxAdapter.DurationStrings), "duration"),
            amount: this.#parametric.createParameter(box.amount, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "amount")
        };
    }
}
